import { COUNTRY } from "@type/country";
import { BRAND_LIST } from "@type/brand";
import { convertEUMinorRegionName } from "@util/country";

import UQJPCountryENV from "./country/UQ/JP";
import UQUSCountryENV from "./country/UQ/US";
import PLJPCountryENV from "./country/PL/jp";
import GUJPCountryENV from "./country/GU/jp";
import UQATCountryENV from "./country/UQ/AT";
import UQBECountryENV from "./country/UQ/BE";
import UQBGCountryENV from "./country/UQ/BG";
import UQCZCountryENV from "./country/UQ/CZ";
import UQDECountryENV from "./country/UQ/DE";
import UQDKCountryENV from "./country/UQ/DK";
import UQEECountryENV from "./country/UQ/EE";
import UQESCountryENV from "./country/UQ/ES";
import UQFICountryENV from "./country/UQ/FI";
import UQFRCountryENV from "./country/UQ/FR";
import UQGRCountryENV from "./country/UQ/GR";
import UQHRCountryENV from "./country/UQ/HR";
import UQHUCountryENV from "./country/UQ/HU";
import UQIECountryENV from "./country/UQ/IE";
import UQITCountryENV from "./country/UQ/IT";
import UQLTCountryENV from "./country/UQ/LT";
import UQLUCountryENV from "./country/UQ/LU";
import UQLVCountryENV from "./country/UQ/LV";
import UQNLCountryENV from "./country/UQ/NL";
import UQPLCountryENV from "./country/UQ/PL";
import UQPTCountryENV from "./country/UQ/PT";
import UQROCountryENV from "./country/UQ/RO";
import UQSECountryENV from "./country/UQ/SE";
import UQSICountryENV from "./country/UQ/SI";
import UQSKCountryENV from "./country/UQ/SK";
import UQUKCountryENV from "./country/UQ/UK";

export const REQUEST_TIMEOUT = 15 * 1000;
export const FIREBASE_CACHE_TIMEOUT = 15 * 60 * 1000;
export const MIN_SCORE = "0.3";
export const IS_SHOW_OUTFIT_WISH_ICON = true;
export const REACT_APP_BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "";
export const UQ_JP_JA_Ios_UserAgent = "com.uniqlo.catalogue";
export const UQ_US_EN_Ios_UserAgent = "com.uniqlo.main.us";
export const UQ_JP_JA_Android_UserAgent = "com.uniqlo.ja.catalogue";
export const UQ_US_EN_Android_UserAgent = "com.uniqlo.usa.catalogue";
export const guIOSPattern = /gu ios application/i;
export const guAndroidPattern = /gu android application/i;
export const FR_UserAgent = "FRNativeApp";
export const REACT_APP_ENV = process.env.REACT_APP_ENV || "";
export const BUILD_VERSION = process.env.BUILD_VERSION || "";
export const UQ_UIKIT_VERSION = process.env.UQ_UIKIT_VERSION || "";
export const GU_UIKIT_VERSION = process.env.GU_UIKIT_VERSION || "";
export const LOCALISATION_VERSION = process.env.LOCALISATION_VERSION || "";
// GU JP
export const GENDER_WOMEN_ID_JP_GU =
  process.env.REACT_APP_GENDER_WOMEN_ID_JP_GU || "";
export const GENDER_MEN_ID_JP_GU =
  process.env.REACT_APP_GENDER_MEN_ID_JP_GU || "";
export const GENDER_KIDS_BABY_ID_JP_GU =
  process.env.REACT_APP_GENDER_KIDS_BABY_ID_JP_GU || "";
// UQ JP
export const GENDER_WOMEN_ID_JP_UQ =
  process.env.REACT_APP_GENDER_WOMEN_ID_JP_UQ || "";
export const GENDER_MEN_ID_JP_UQ =
  process.env.REACT_APP_GENDER_MEN_ID_JP_UQ || "";
export const GENDER_KIDS_ID_JP_UQ =
  process.env.REACT_APP_GENDER_KIDS_ID_JP_UQ || "";
export const GENDER_BABY_ID_JP_UQ =
  process.env.REACT_APP_GENDER_BABY_ID_JP_UQ || "";
// UQ US
export const GENDER_WOMEN_ID_US_UQ =
  process.env.REACT_APP_GENDER_WOMEN_ID_US_UQ || "";
export const GENDER_MEN_ID_US_UQ =
  process.env.REACT_APP_GENDER_MEN_ID_US_UQ || "";
export const GENDER_KIDS_ID_US_UQ =
  process.env.REACT_APP_GENDER_KIDS_ID_US_UQ || "";
export const GENDER_BABY_ID_US_UQ =
  process.env.REACT_APP_GENDER_BABY_ID_US_UQ || "";
// UQ UK
export const GENDER_WOMEN_ID_UK_UQ =
  process.env.REACT_APP_GENDER_WOMEN_ID_UK_UQ || "";
export const GENDER_MEN_ID_UK_UQ =
  process.env.REACT_APP_GENDER_MEN_ID_UK_UQ || "";
export const GENDER_KIDS_ID_UK_UQ =
  process.env.REACT_APP_GENDER_KIDS_ID_UK_UQ || "";
export const GENDER_BABY_ID_UK_UQ =
  process.env.REACT_APP_GENDER_BABY_ID_UK_UQ || "";
// UQ EU
export const GENDER_WOMEN_ID_EU_UQ =
  process.env.REACT_APP_GENDER_WOMEN_ID_EU_UQ || "";
export const GENDER_MEN_ID_EU_UQ =
  process.env.REACT_APP_GENDER_MEN_ID_EU_UQ || "";
export const GENDER_KIDS_ID_EU_UQ =
  process.env.REACT_APP_GENDER_KIDS_ID_EU_UQ || "";
export const GENDER_BABY_ID_EU_UQ =
  process.env.REACT_APP_GENDER_BABY_ID_EU_UQ || "";

export const IS_ENV = (brand: string, region: string): any => {
  switch (`${brand}${convertEUMinorRegionName(region)}`) {
    case `${BRAND_LIST.UQ}${COUNTRY.JP}`:
      return UQJPCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.US}`:
      return UQUSCountryENV;
    case `${BRAND_LIST.PL}${COUNTRY.JP}`:
      return PLJPCountryENV;
    case `${BRAND_LIST.GU}${COUNTRY.JP}`:
      return GUJPCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.AT}`:
      return UQATCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.BE}`:
      return UQBECountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.BG}`:
      return UQBGCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.CZ}`:
      return UQCZCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.DE}`:
      return UQDECountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.DK}`:
      return UQDKCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.EE}`:
      return UQEECountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.ES}`:
      return UQESCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.FI}`:
      return UQFICountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.FR}`:
      return UQFRCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.GR}`:
      return UQGRCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.HR}`:
      return UQHRCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.HU}`:
      return UQHUCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.IE}`:
      return UQIECountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.IT}`:
      return UQITCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.LT}`:
      return UQLTCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.LU}`:
      return UQLUCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.LV}`:
      return UQLVCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.NL}`:
      return UQNLCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.PL}`:
      return UQPLCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.PT}`:
      return UQPTCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.RO}`:
      return UQROCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.SE}`:
      return UQSECountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.SI}`:
      return UQSICountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.SK}`:
      return UQSKCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.UK}`:
      return UQUKCountryENV;
    default:
      return UQJPCountryENV;
  }
};
